import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Briefcase, ClipboardCheck, Landmark, Compass } from "lucide-react";
import { personas } from "../../mock/workflows";
import { SectionLabel } from "../shared";

const icons = [ShieldCheck, Briefcase, ClipboardCheck, Landmark, Compass];

export default function PersonasSection() {
  return (
    <section className="max-w-[1320px] mx-auto px-5 lg:px-8 py-20">
      <SectionLabel color="#12B76A">Who is RiskPedia USA for</SectionLabel>
      <h2 className="font-display font-bold text-[34px] lg:text-[46px] leading-[1.08] tracking-tight max-w-3xl">
        One platform — <span className="text-[#12B76A]">five distinct journeys.</span>
      </h2>
      <p className="mt-4 text-[16px] text-[#1A1914]/60 max-w-2xl">
        Pick the path that matches your role. Each persona gets a tailored zone with the templates, trackers and intel that actually solve their daily pain — not generic content.
      </p>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="persona-cards">
        {personas.map((p, i) => {
          const Icon = icons[i % icons.length];
          return (
            <div key={p.title} className="rp-card bg-white border border-[#E7E0D2] rounded-2xl p-6 flex flex-col">
              <div className="flex items-center justify-between">
                <div className="w-10 h-10 rounded-xl bg-[#F3EEE4] flex items-center justify-center text-[#3F4CE0]"><Icon size={19} /></div>
                {p.tag && <span className="font-mono-label text-[10px] px-2 py-0.5 rounded-full bg-[#12B76A]/10 text-[#0E9355] border border-[#12B76A]/25">{p.tag}</span>}
              </div>
              <h3 className="mt-4 font-display font-semibold text-[21px]">{p.title}</h3>
              <p className="mt-1 font-mono-label text-[10px] text-[#1A1914]/45 leading-relaxed normal-case tracking-wide">{p.who.toUpperCase()}</p>
              <p className="mt-3 text-[13.5px] leading-relaxed text-[#1A1914]/60"><strong className="text-[#1A1914]/80">The pain:</strong> {p.pain}</p>
              <div className="mt-4">
                <p className="font-mono-label text-[10px] text-[#1A1914]/40 mb-2">What they get</p>
                <ul className="space-y-1.5">
                  {p.gets.map((g) => (
                    <li key={g} className="text-[13px] text-[#3F4CE0] flex items-center gap-1.5"><span className="w-1 h-1 rounded-full bg-[#3F4CE0]" />{g}</li>
                  ))}
                </ul>
              </div>
              <Link to={p.link} className="mt-5 pt-4 border-t border-[#E7E0D2] inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-[#1A1914] hover:text-[#3F4CE0] rp-btn mt-auto">
                {p.cta} <ArrowRight size={14} />
              </Link>
            </div>
          );
        })}
        <div className="rp-card bg-[#14130F] text-white rounded-2xl p-6 flex flex-col justify-between">
          <div>
            <p className="font-mono-label text-[10px] text-white/40">Money Flow · New</p>
            <h3 className="mt-3 font-display font-semibold text-[22px] leading-snug">Follow $6.8T from Washington to your county.</h3>
            <p className="mt-3 text-[13.5px] text-white/60 leading-relaxed">Federal → state → county money flow on an interactive USA map, with risk flags and mitigation playbooks per state.</p>
          </div>
          <Link to="/money-flow" data-testid="persona-moneyflow-cta" className="mt-5 inline-flex items-center gap-2 px-5 py-3 text-[14px] font-semibold text-[#14130F] bg-white hover:bg-[#F3EEE4] rounded-xl rp-btn self-start">
            Open the map <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
